<template>
  <div class="legal-disclaimer-overlay">
    <div class="legal-disclaimer-container">
      <h3 class="">Confidentiality Agreement</h3>

      <div class="disclaimer-content">
        <p>
          Welcome to The33Path. Before proceeding, please read the following
          confidentiality agreement:
        </p>

        <div class="terms-container">
          <p>
            <strong>Confidential Information:</strong> All materials, including
            but not limited to concepts, stories, characters, scripts, visual
            content, and business documentation, are confidential and
            proprietary to The Path and its creators.
          </p>

          <p>
            <strong>Non-Disclosure:</strong> You agree not to share, reproduce,
            distribute, or disclose any part of this material - in whole or in
            part - without prior written authorization from The Path.
          </p>

          <p>
            <strong>Intellectual Property:</strong> All creative and
            intellectual property rights remain the sole and exclusive property
            of The Path and its affiliated entities. Access does not grant any
            license, ownership, or usage rights.
          </p>

          <p>
            <strong>Limited Access:</strong> Access is granted for private,
            evaluative, or viewing purposes only. No commercial, promotional, or
            derivative use of this content is permitted.
          </p>

          <p>
            <strong>Termination & Legal Protection:</strong> The Path reserves
            the right to suspend or revoke access at any time in the event of a
            breach of these terms. Unauthorized use or disclosure may result in
            legal action.
          </p>
        </div>
      </div>

      <div class="action-buttons">
        <button class="accept-button" @click="$emit('close')">
          I Understand
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PreLoginLegalDisclaimer",
  emits: ["close"],
};
</script>

<style scoped>
/* Copy all styles from LegalDisclaimer.vue */
.legal-disclaimer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.legal-disclaimer-container {
  background-color: var(--bg-main-dark);
  border: 1px solid var(--border-light);
  border-radius: var(--border-radius-medium);
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  padding: var(--largeSpace);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.disclaimer-content {
  overflow-y: auto;
  margin: var(--space) 0;
  padding-right: var(--space);
}

.terms-container {
  margin: var(--space) 0;
  padding: var(--space);
  border: 1px solid var(--border-light);
  border-radius: var(--border-radius-small);
  background-color: rgba(255, 255, 255, 0.05);
}

.terms-container p {
  margin-bottom: var(--space);
}

.final-note {
  font-style: italic;
  margin-top: var(--space);
}

.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: var(--space);
}

.accept-button {
  padding: 10px 30px;
  font-size: 1.2rem;
  background-color: transparent;
  border: 1px solid var(--text-white);
  color: var(--text-white);
  border-radius: var(--border-radius-pill);
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.accept-button:hover:not(:disabled) {
  background-color: var(--button-hover-background);
}

.accept-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .legal-disclaimer-container {
    padding: var(--space);
    max-height: 80vh;
  }

  .terms-container {
    padding: var(--smallSpace);
  }
}
</style>
